var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect, useCallback } from 'react';
import { useRouteMatch, useHistory, useLocation } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { ITEM_REQUEST, MARKET_LIST_REQUEST, SPEC_REQUEST, STDPC_SPEC_REQUEST, STDPC_OPTION_REQUEST, SET_PRICE_DATA, SET_DETAIL_PAGE_TYPE, SET_DETAIL_POPUP_PAGE, } from '../../reducers/product';
import Nav from '../nav';
import ProductHead from '../product_head';
import SummaryInfo from '../summary_info';
import BrandProduct from '../brand_product';
import AdvBanner from '../adv/banner';
import Tab from '../tab';
import StdpcUnder from '../stdpc_under';
import { gaViewItemProcess } from '../libs/googleTagmanager';
import { priceState } from '../../utils/util';
import styled from "styled-components";
import SeoLayout from "../../layouts/seo";
var DEFAULT = {
    item_id: '5586638', // 6143013,9809884, 7549747, 10237341
};
var isDev = process.env.NODE_ENV === 'development';
var Main = function () {
    var _a, _b;
    var item = useSelector(function (state) { return state.product.item; });
    var itemLoaded = useSelector(function (state) { return state.product.itemLoaded; });
    /**
     * 조립PC 더보기 POP-UP 페이지 여부 확인을 위한 변수
     */
    var isPopUp = useSelector(function (state) { return state.product.isPopUp; });
    var match = useRouteMatch();
    var history = useHistory();
    var dispatch = useDispatch();
    var search = useLocation().search;
    var isMinishop = Boolean(match.params.idx_b_manager);
    var _c = match.params, idx_b_manager = _c.idx_b_manager, item_id = _c.item_id;
    /**
     * 조립PC 더보기 POP-UP 일 경우 헤더와 푸터가 비노출 처리 되야함
     * 이를 위한 DOM 변수 생성
     */
    var GNB_HEADER_DOM = document.querySelector('header');
    var GNB_FOOTER_DOM = document.querySelector('footer');
    var goErrorPage = useCallback(function () {
        window.location.href = "".concat(process.env.REACT_APP_WWW_URL, "/sorry");
    }, []);
    var priceObj = {
        price: isMinishop ? ((_a = item === null || item === void 0 ? void 0 : item.minishop) === null || _a === void 0 ? void 0 : _a.price_b2c) || 0 : (item === null || item === void 0 ? void 0 : item.price_low) || 0,
        f_sellout: (item === null || item === void 0 ? void 0 : item.f_sellout) || 0,
        cnt_strock: ((_b = item === null || item === void 0 ? void 0 : item.minishop) === null || _b === void 0 ? void 0 : _b.cnt_stock) || 0,
        seller: (item === null || item === void 0 ? void 0 : item.seller) || 0,
        isMinishop: isMinishop,
    };
    var priceData = priceState(priceObj);
    useEffect(function () {
        fetchPriceData();
    }, [priceData]);
    var fetchPriceData = function () {
        dispatch({
            type: SET_PRICE_DATA,
            payload: priceData,
        });
    };
    var urlValidator = useCallback(function () {
        if (isDev) {
            if (!match.params.item_id) {
                window.location.href = "/detail/".concat(DEFAULT.item_id);
                return;
            }
        }
        if (!match.params.item_id) {
            // alert("관리자에게 문의 바랍니다. \nerror case is not item_id")
            goErrorPage();
        }
        if (!item && itemLoaded) {
            // alert("관리자에게 문의 바랍니다. \nerror case loading process is over. But there is no item.")
            goErrorPage();
        }
        if (match.params.idx_b_manager) {
            // 2022-08-04 조립PC 는 상품상태 상관없이 노출되게 수정
            if (((item === null || item === void 0 ? void 0 : item.f_sellout) === 2 || (item === null || item === void 0 ? void 0 : item.f_sellout) === 12) && (item === null || item === void 0 ? void 0 : item.cate_id.toString().slice(0, 1)) !== '2') {
                // alert(`관리자에게 문의 바랍니다. \nerror case is not idx_b_manager and f_sellout=${item?.f_sellout}`)
                goErrorPage();
            }
        }
        if (item) {
            if (!match.params.idx_b_manager && item.cate_id.toString().slice(0, 1) === '2') {
                history.push("/detail/".concat(match.params.item_id, "/3"));
                // window.location.href = `/detail/${match.params.item_id}/1`
            }
        }
    }, [match.params, item, itemLoaded]);
    var fetchItem = useCallback(function () {
        dispatch({
            type: ITEM_REQUEST,
            payload: {
                item_id: item_id,
                idx_b_manager: idx_b_manager,
            },
        });
    }, [match.params]);
    var fetchMarketList = useCallback(function () {
        dispatch({
            type: MARKET_LIST_REQUEST,
            payload: {
                item_id: item_id,
            },
        });
    }, [match.params]);
    var fetchSpec = useCallback(function () {
        dispatch({
            type: SPEC_REQUEST,
            payload: {
                item_id: item_id,
            },
        });
    }, [match.params]);
    var fetchStdpcSpec = useCallback(function () {
        dispatch({
            type: STDPC_SPEC_REQUEST,
            payload: {
                item_id: item_id,
                idx_b_manager: idx_b_manager,
            },
        });
    }, [match.params]);
    var fetchStdpcOption = useCallback(function () {
        dispatch({
            type: STDPC_OPTION_REQUEST,
            payload: {
                item_id: item_id,
                idx_b_manager: idx_b_manager,
            },
        });
    }, [match.params]);
    var priceDataText = useSelector(function (state) { return state.product.priceStateText; });
    useEffect(function () {
        fetchItem();
        fetchMarketList();
        fetchSpec();
    }, []);
    useEffect(function () {
        urlValidator();
    }, [match.params, item, itemLoaded]);
    useEffect(function () {
        if (item) {
            if (item.cate_id.toString().slice(0, 1) === '2') {
                fetchStdpcSpec();
                fetchStdpcOption();
            }
            gaViewItemProcess(item);
        }
    }, [item]);
    useEffect(function () {
        var params = new URLSearchParams(search);
        var type = Number(params.get('type'));
        var popup = params.get('popup');
        if (search.includes("ad_code")) {
            setTimeout(function () {
                if (search.includes("ad_code")) {
                    var queryStringAdCode = new URLSearchParams(search).get('ad_code');
                    if (queryStringAdCode === 'dap007') {
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth',
                        });
                    }
                    if (queryStringAdCode === 'dap008') {
                        var element = document.getElementById("dap008_ad");
                        element && element.scrollIntoView({ behavior: 'smooth' });
                    }
                }
            }, 3000);
        }
        /**
         * URL에 type을 감지하여 Redux에 업데이트
         */
        if (type > 0) {
            dispatch({
                type: SET_DETAIL_PAGE_TYPE,
                payload: {
                    detailPageType: type
                },
            });
        }
        else {
            dispatch({
                type: SET_DETAIL_PAGE_TYPE,
                payload: {
                    detailPageType: 0
                },
            });
        }
        /**
         * Url에서 popup 여부를 확인하여 redux에 업데이트
         */
        if (popup) {
            dispatch({
                type: SET_DETAIL_POPUP_PAGE,
                payload: {
                    isPopUp: true
                },
            });
        }
        else {
            dispatch({
                type: SET_DETAIL_POPUP_PAGE,
                payload: {
                    isPopUp: false
                },
            });
        }
    }, [search]);
    /**
     * popup인 경우
     * 헤더와 푸터를 비노출 처리함
     */
    useEffect(function () {
        if (GNB_HEADER_DOM && GNB_FOOTER_DOM) {
            if (isPopUp) {
                GNB_HEADER_DOM.style.display = 'none';
                GNB_FOOTER_DOM.style.display = 'none';
            }
            else {
                GNB_HEADER_DOM.style.display = 'block';
                GNB_FOOTER_DOM.style.display = 'block';
            }
        }
    }, [isPopUp]);
    var today = new Date();
    return (React.createElement(React.Fragment, null,
        React.createElement(SeoLayout, null),
        React.createElement("div", null,
            !isPopUp &&
                React.createElement(React.Fragment, null,
                    React.createElement(Nav, null),
                    React.createElement(ProductHead, null),
                    React.createElement(SummaryInfo, null),
                    React.createElement(BrandProduct, null),
                    React.createElement(AdvBanner, null)),
            React.createElement(Tab, null),
            " ",
            match.params.idx_b_manager &&
                (item === null || item === void 0 ? void 0 : item.cate_id.toString().slice(0, 1)) === '2' &&
                priceDataText === 'price' && React.createElement(StdpcUnder, null),
            isPopUp && React.createElement(BottomMargin, null))));
};
export default Main;
/**
 * POP-UP일 경우 하단에 푸터가 없기 때문에, 최하단에 여백 추가
 */
var BottomMargin = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    height: 105px;\n"], ["\n    width: 100%;\n    height: 105px;\n"])));
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/main/index.tsx
// module id = 175
// module chunks = 0